import React from "react";
import STRINGS from "../../constants/strings";
import { Modal } from "react-bootstrap";

export default function OurStory(props) {
  const { showOurStory, closeModal } = props;
  return (
    <Modal show={showOurStory} onHide={() => closeModal()}>
      <Modal.Header closeButton>
        <h2 className="text-capitalize text-center">About Us</h2>
      </Modal.Header>
      <Modal.Body>
        <div className="heading">
          <h2 className="text-capitalize text-center">{STRINGS.OURSTORY}</h2>
        </div>
        <p className="content">{STRINGS.OURSTORY_DESC}</p>
        <div className="heading">
          <h2 className="text-capitalize text-center">{STRINGS.OUR_HISTORY}</h2>
        </div>
        <p className="content">{STRINGS.OUR_HISTORY_DESC}</p>
      </Modal.Body>
    </Modal>
  );
}
